import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";


import Typography from "@material-ui/core/Typography";
import KpiGrid from "./KpiGrid";
import {convertSecondsToHourMinutesFormat} from "../../../../common/Util";





const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px',
      flexGrow: 1
    },
    gridTitulo: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',


        border: 1,
    //    borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: "center",
        alignContent: 'center',
        border: 1,
     //   borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },


}));


export default function OperadorKpis(props) {
  const { dataOper} = props;

  const classes = useStyles();


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid container item id={'titulo'} className={classes.gridTitulo} sm={12} md={12}>
            <Typography>OPERADOR {dataOper.usuario}</Typography>
        </Grid>
        <Grid container item id={'gridCorrecaoAjuste'} className={classes.gridItem}  sm={12} md={12} >
            <Grid container item className={classes.gridItem}  xs={12} sm={12} md={12}>

                <KpiGrid
                    valor={dataOper.numRaspagens}
                    titulo={<span>RASPAGENS</span>}
                    descricao={''}
                    unidadeValor=""
                />
                <KpiGrid
                    valor={ Math.round(dataOper.avgTempoEsperaOper)}
                    titulo={<span>TEMPO ESPERA</span>}
                    descricao={''}
                    unidadeValor='"'
                />

                <KpiGrid
                    valor={ convertSecondsToHourMinutesFormat(dataOper.tempoCiclo)}
                    titulo={<span>HORAS EM MAQ.</span>}
                    descricao={''}
                    unidadeValor="'"
                />

                <KpiGrid
                    valor={ Math.round((dataOper.numRaspagensComOS / dataOper.numRaspagens) * 100) }
                    titulo={<span>COM O.S.</span>}
                    descricao={''}
                    unidadeValor="%"
                />
                <KpiGrid
                    valor={ Math.round((dataOper.numRaspagensComReceita / dataOper.numRaspagensComOS) * 100)}
                    titulo={<span>USO DE RECEITAS</span>}
                    descricao={''}
                    unidadeValor="%"
                />
                <KpiGrid
                    valor={ Math.round((dataOper.numRaspagensSemAproveitarReceita / dataOper.numRaspagensComOS) * 100)}
                    titulo={<span>RECEITAS NÃO APROVEITADAS</span>}
                    descricao={''}
                    unidadeValor="%"
                />
            </Grid>




        </Grid>
    </Grid>
  )
}
;
